import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import _ from 'lodash';

const COLORS = [
    '#0d47a1',
    '#1565c0',
    '#1976d2',
    '#1e88e5',
    '#2196f3',
    '#42a5f5',
    '#64b5f6',
    '#90caf9',
    '#bbdefb',
    '#e3f2fd'
];

const MAX_ROWS = 15;

export default class CategoriesChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allVisible: false
        };
    }
    render() {
        return (
            <div className="CitingResearchCategoriesTab-chart-wrapper">
                <div className="CitingResearchCategoriesTab-chart">
                    <HighchartsReact highcharts={Highcharts} options={this.chartConfig} />
                </div>
                {this.researchCategoriesLegend}
            </div>
        );
    }

    get chartConfig() {
        return {
            credits: false,
            chart: {
                type: 'pie',
                height: 600,
                style: {
                    fontFamily: 'roboto-webfont'
                }
            },
            title: false,
            tooltip: {
                headerFormat: '',
                pointFormat:
                    '<span style="color:{point.color}">\u25CF</span> {point.name}: <b>{point.percentage:.2f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    dataLabels: false,
                    showInLegend: false,
                    colors: COLORS
                }
            },
            series: [
                {
                    name: 'Categories',
                    data: this.data
                }
            ]
        };
    }

    get data() {
        return _.map(this.props.categories, function (cat) {
            return {
                name: cat.name,
                y: cat.count
            };
        });
    }

    get visibleCategories() {
        if (this.state.allVisible) {
            return this.props.categories;
        } else {
            return this.props.categories.slice(0, MAX_ROWS);
        }
    }

    get researchCategoriesLegend() {
        return (
            <div className="CitingResearchCategoriesTab-legend">
                {this.legendButton}
                <table>
                    <thead>
                        <tr>
                            <th className="category-color"></th>
                            <th className="category-name">Research Category (FOR code)</th>
                            <th className="category-percentage">%</th>
                        </tr>
                    </thead>
                    <tbody>{this.researchCategoriesRows}</tbody>
                </table>
                {this.legendButton}
            </div>
        );
    }

    get legendButton() {
        if (this.props.categories.length <= MAX_ROWS) {
            return null;
        }

        let label = this.state.allVisible ? 'buttons.show_fewer_categories' : 'buttons.show_more_categories';
        let hidden = this.props.categories.length - MAX_ROWS;

        return (
            <div className="CitingResearchCategoriesTab-button">
                <a href="#" onClick={e => this.handleClick(e)}>
                    [ {I18n.t(label, { count: hidden })} ]
                </a>
            </div>
        );
    }

    get researchCategoriesRows() {
        let total = _.sumBy(this.props.categories, 'count');

        return this.visibleCategories.map((category, index) => this.researchCategoryRow(index, category, total));
    }

    handleClick(event) {
        event.preventDefault();

        this.setState({ allVisible: !this.state.allVisible });
    }

    researchCategoryRow(index, category, total) {
        return (
            <tr key={index}>
                <td className="category-color" style={{ backgroundColor: this.categoryColor(index) }}></td>
                <td className="category-name">{category.name}</td>
                <td className="category-percentage">{this.categoryPercentage(category, total)}</td>
            </tr>
        );
    }

    categoryPercentage(category, total) {
        let value = ((category.count / total) * 100).toFixed(2);

        if (value < 0.01) {
            return '< 0.01';
        } else {
            return value;
        }
    }

    categoryColor(index) {
        let colorIndex = index % COLORS.length;

        return COLORS[colorIndex];
    }
}
